export class UserBlob {
    constructor(
        public id?: string,
        public userBlob?: any,
        public userBlobContentType?: any,
        public userBlobSize?: any,
        public userBlobFilename?: any,
        public creationDate?: Date,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/upload/user-blob.model.ts